import { render, staticRenderFns } from "./DialogSolicitacaoRetirada.vue?vue&type=template&id=82a3d46e"
import script from "./DialogSolicitacaoRetirada.vue?vue&type=script&lang=js"
export * from "./DialogSolicitacaoRetirada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports